/**
 * Utilities for Cards
 */

export function parseTrackingAttributes(
  attributes: string,
): Record<string, string> {
  try {
    const parsed: unknown = JSON.parse(attributes);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed))
      return {};
    const out: Record<string, string> = {};
    for (const [key, val] of Object.entries(
      parsed as Record<string, unknown>,
    )) {
      if (key.startsWith("data-")) out[key] = String(val);
    }
    return out;
  } catch {
    const out: Record<string, string> = {};
    let s = attributes.trim();
    if (s.startsWith("{") && s.endsWith("}")) s = s.slice(1, -1);
    if (!s) return out;

    for (const part of s.split(",")) {
      const [k, ...rest] = part.split("=");
      if (!k || rest.length === 0) continue;
      const key = k.trim();
      let value = rest.join("=").trim();
      if (!key.startsWith("data-")) continue;

      if (
        (value.startsWith('"') && value.endsWith('"')) ||
        (value.startsWith("'") && value.endsWith("'"))
      ) {
        value = value.slice(1, -1);
      }

      out[key] = value;
    }

    return out;
  }
}
